import React from "react"
import FlorImg from "../../../images/flor.svg"
import AyampeImg from "../../../images/ayampe.png"
import Ayampe2Img from "../../../images/ayampe2.png"
import Agus2Img from "../../../images/agus2.svg"

const Ayampe = () => {
  return (
    <section className="container mx-auto px-6 py-20">
      <div className="flex flex-col-reverse md:flex-row items-center lg:w-2/3 mx-auto">
        <div className="w-full md:w-2/3">
          <p className="pb-4 text-xl">
            Our location in <b>Ayampe is perfect to disconnect</b> from the
            hectic pace of everyday life. Whether you want to invest in yourself
            or enjoy the outdoors with the people you share your workday with,
            it's time to travel off-grid and reconnect with what matters!
          </p>
          <p className="text-secondary text-center md:text-left">Florencia Diez, Avalither Staff</p>
        </div>
        <div className="w-full md:w-1/3 pb-8 hidden md:block">
          <img
            src={FlorImg}
            alt="Florencia Diez, Avalither Staff"
            className="mx-auto"
          />
        </div>
      </div>
      {/* ayampe ecuador */}
      <div className="flex flex-col-reverse md:flex-row py-20">
        <div className="w-full md:w-1/2 p-4">
          <h3 className="text-5xl font-light pb-4 leading-snug">
            <span className="block text-tertiary font-bold">Ayampe</span>{" "}
            Ecuador
          </h3>
          <h4 className="text-3xl text-tertiary pb-4">Where it all began</h4>
          <p className="pb-4">
            We founded Work & Travel in 2013, it all started by chance when
            Agustín, Joaquín and Florencia traveled the coasts of Ecuador in
            search of new waves and it was at that moment that they found
            Ayampe.
          </p>
          <p className="pb-4">
            A beautiful, unique and ideal place to develop a nomadic lifestyle
            maintaining a harmony between professional development, cultural
            enrichment, and enjoying an environment surrounded by nature with
            incredible waves.
          </p>
        </div>
        <div className="w-full md:w-1/2">
          <img src={AyampeImg} alt="Ayampe Ecuador" className="mx-auto" />
        </div>
      </div>

      <div className="flex flex-col-reverse md:flex-row-reverse pb-20 items-center">
        <div className="w-full md:w-1/2 pt-4">
          <h4 className="text-3xl text-tertiary pb-4">Our Discovery</h4>
          <p className="pb-4">
            From that day on, we decided to carry out the Work & Travel
            experience, improving year after year, providing accommodation,
            improving Internet connectivity, adding new activities that allow us
            to understand, learn and enter the local culture, but above all,
            creating unique experiences, while forming amazing new friendships.
          </p>
        </div>
        <div className="w-full md:w-1/2">
          <img src={Ayampe2Img} alt="Ayampe Ecuador" className="mx-auto" />
        </div>
      </div>

      <div className="text-center w-full lg:w-1/2 mx-auto">
        <img src={Agus2Img} alt="Agustin Antonino, Avalither CEO" className="mx-auto pb-8" />
        <p className="text-2xl pb-4 font-medium">
          Our first Work & Travel showed us the need to provide remote work
          opportunities in different places, to enjoy unique places and cultural
          enrichment.
        </p>
        <p className="text-tertiary italic">Agustin Antonino, Avalither CEO</p>
      </div>
    </section>
  )
}

export default Ayampe
